/**
 * BotGlyph - 챗봇 아이콘 (로봇 얼굴 라인 아이콘)
 * ChatPage 아바타 · ThemeEditorModal 미리보기 공통
 * 선 색 = currentColor (감싼 요소의 color 로 테마 아이콘 색상 적용)
 */

interface BotGlyphProps {
  size?: number;
  className?: string;
}

export function BotGlyph({ size = 16, className }: BotGlyphProps) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="4" y="8" width="16" height="12" rx="3" />
      <path d="M12 4v4M9 13v1M15 13v1M2 13v3M22 13v3" />
      <circle cx="12" cy="3.5" r="1" />
    </svg>
  );
}

export default BotGlyph;
